import { Get, Post } from "src/shared/services/Fetch";
import {
  getCurrentLender,
  getCurrentOrganisation,
  noHeadersResponse
} from "src/shared/utils/Global";
import { LENDER_NAMES } from "src/shared/utils/constants";
import { getStoredProgrammeType } from "src/shared/utils/platformAuth";
import { IVKYCDataPayload } from "./VerificationVKYC.types";

const useV2 = () => {
  const currentLender = getCurrentLender();
  const currentOrganisation = getCurrentOrganisation();

  return (
    currentLender === LENDER_NAMES.HFCL ||
    currentLender === LENDER_NAMES.MFL_LAP ||
    currentLender === LENDER_NAMES.ABFL_CO_LENDING ||
    currentOrganisation === LENDER_NAMES.HFCL ||
    currentOrganisation === LENDER_NAMES.MFL_LAP
  );
};

class VerificationVKYCService {
  static async getVKYCData({
    token,
    loanApplicationID,
    pageName,
    userID,
    isLenderDashboard = true
  }: IVKYCDataPayload) {
    try {
      const headers = new Headers();
      if (pageName) {
        headers.append("page-header", pageName);
      } else {
        return noHeadersResponse();
      }

      const payload = {
        loanApplicationID,
        resourceName: "vkyc_tab",
        service: isLenderDashboard ? "lender_dashboard" : "master_dashboard",
        userID: userID,
        ...(useV2() && { programType: getStoredProgrammeType() })
      };

      const url = `/${
        isLenderDashboard ? "lender" : "masterDashboard"
      }/fetch-uiconfig`;
      const response = await Post(url, token, payload, headers);

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async getVideoPDData({
    token,
    loanApplicationID,
    pageName,
    userID,
    isLenderDashboard = true
  }: IVKYCDataPayload) {
    try {
      const headers = new Headers();
      if (pageName) {
        headers.append("page-header", pageName);
      } else {
        return noHeadersResponse();
      }

      const payload = {
        loanApplicationID,
        resourceName: "vpd_tab",
        service: isLenderDashboard ? "lender_dashboard" : "master_dashboard",
        userID: userID,
        ...(useV2() && { programType: getStoredProgrammeType() })
      };
      const url = `/${
        isLenderDashboard ? "lender" : "masterDashboard"
      }/fetch-uiconfig`;
      const response = await Post(url, token, payload, headers);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}

export default VerificationVKYCService;
